var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagAustralia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 75,
    viewBox: "0 0 76 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_725_8027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.75 37.5C75.75 58.2105 58.9605 75 38.25 75C17.5395 75 0.75 58.2105 0.75 37.5C0.75 37.5088 38.25 0.00424805 38.25 0C58.9605 0 75.75 16.7895 75.75 37.5Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.25 0C38.2479 0 38.2457 0.0015625 38.2437 0.0015625L38.25 0Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1494 37.5H38.2498C38.2498 37.466 38.2498 37.4335 38.2498 37.3997C38.2164 37.4332 38.183 37.4666 38.1494 37.5Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.25 19.5653C38.25 12.9669 38.25 8.64314 38.25 0.00012207H38.2437C17.5359 0.00349121 0.75 16.7913 0.75 37.5H20.3152V26.4826L31.3326 37.5H38.1498C38.1833 37.4666 38.2167 37.4332 38.2501 37.3996C38.2501 34.8732 38.2501 32.619 38.2501 30.5828L27.2326 19.5653H38.25Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7218 4.89124C13.8567 8.23093 8.98081 13.1068 5.64111 18.9719V37.5H15.4238V14.6741V14.6739H38.2499C38.2499 11.5885 38.2499 8.64915 38.2499 4.89124H19.7218Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2501 32.8885L24.9269 19.5655H20.3154C20.3154 19.5653 20.3154 19.5655 20.3154 19.5655L38.2499 37.5H38.2501C38.2501 37.5 38.2501 34.3206 38.2501 32.8885Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3667 44.0219L25.4248 48.3253L30.0723 47.2511L27.991 51.5434L31.7284 54.5072L27.075 55.556L27.0881 60.3261L23.3667 57.3418L19.6454 60.3261L19.6584 55.556L15.0049 54.5072L18.7424 51.5434L16.6609 47.2511L21.3087 48.3253L23.3667 44.0219Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8952 52.174L57.9242 54.3257L60.2481 53.7885L59.2073 55.9346L61.0762 57.4166L58.7494 57.941L58.7558 60.3261L56.8952 58.8339L55.0345 60.3261L55.041 57.941L52.7144 57.4166L54.5831 55.9346L53.5424 53.7885L55.8661 54.3257L56.8952 52.174Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3226 29.3479L48.3515 31.4998L50.6753 30.9624L49.6347 33.1086L51.5034 34.5906L49.1768 35.115L49.1831 37.5L47.3226 36.0078L45.4619 37.5L45.4682 35.115L43.1416 34.5906L45.0103 33.1086L43.9697 30.9624L46.2935 31.4998L47.3226 29.3479Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8952 16.3043L57.9242 18.4562L60.2481 17.919L59.2075 20.0652L61.076 21.547L58.7494 22.0716L58.7558 24.4566L56.8952 22.9644L55.0345 24.4566L55.041 22.0716L52.7144 21.547L54.5829 20.0652L53.5424 17.919L55.8661 18.4562L56.8952 16.3043Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2571 26.087L66.286 28.2389L68.6099 27.7016L67.5692 29.8477L69.4379 31.3297L67.1112 31.8543L67.1176 34.2392L65.2571 32.7471L63.3965 34.2392L63.4028 31.8543L61.0762 31.3297L62.9449 29.8477L61.9043 27.7016L64.2279 28.2389L65.2571 26.087Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2779 37.5L60.0872 39.9911H62.7067L60.5875 41.5308L61.3971 44.0218L59.2779 42.4822L57.1588 44.0218L57.9682 41.5308L55.8491 39.9911H58.4684L59.2779 37.5Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_725_8027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagAustralia);
export default __webpack_public_path__ + "static/media/flagAustralia.4aebd0919e42b9c2b3118bc2fd64d659.svg";
export { ForwardRef as ReactComponent };